import { render } from "./MenusEdit.vue?vue&type=template&id=4854566a&scoped=true"
import script from "./MenusEdit.vue?vue&type=script&lang=js"
export * from "./MenusEdit.vue?vue&type=script&lang=js"

import "./MenusEdit.vue?vue&type=style&index=0&id=4854566a&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4854566a"]])

export default __exports__